import type React from "react";
import { useState } from "react";
import { Card } from "@/components/ui/card";
import { Checkbox } from "@/components/ui/checkbox";
import { MembershipAgreementModal } from "./membership-agreement-modal";

type Props = {
  agreed: boolean;
  setAgreed: React.Dispatch<React.SetStateAction<boolean>>;
};

export function CommitmentCard({ agreed, setAgreed }: Props) {
  const [isMembershipAgreementModalOpen, setIsMembershipAgreementModalOpen] =
    useState(false);
  return (
    <div className="space-y-4">
      <h3 className="text-base leading-normal font-medium mb-1">
        Accept membership terms
      </h3>
      <p className="text-sm leading-5 font-normal text-text-dark-low">
        Review the details and reach out with any questions.
      </p>
      <Card className="p-4 space-y-2 border border-border-dark-low shadow-none">
        <div className="flex items-start gap-2">
          <Checkbox
            checked={agreed}
            onCheckedChange={(val: boolean) => setAgreed(val)}
          />
          <p className="text-sm leading-5 font-normal text-text-dark-high">
            I agree to{" "}
            <a
              onClick={(e) => {
                e.preventDefault();
                setIsMembershipAgreementModalOpen(true);
              }}
              className="underline cursor-pointer"
            >
              Membership Agreement and Autopay Terms
            </a>
          </p>
        </div>
      </Card>
      <MembershipAgreementModal
        open={isMembershipAgreementModalOpen}
        onClose={() => setIsMembershipAgreementModalOpen(false)}
      />
    </div>
  );
}
